import { render, staticRenderFns } from "./ButtonFloatWhatsapp.vue?vue&type=template&id=6172774d&scoped=true"
import script from "./ButtonFloatWhatsapp.vue?vue&type=script&lang=js"
export * from "./ButtonFloatWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./ButtonFloatWhatsapp.vue?vue&type=style&index=0&id=6172774d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172774d",
  null
  
)

export default component.exports